module.exports = __webpack_public_path__ + "img/new client icon.4792e20a.svg";